import {
	FormControl,
	Grid,
	IconButton,
	Menu,
	MenuItem,
	Popover,
	TableCell,
	TableRow,
	TextField,
	Tooltip,
} from '@material-ui/core';
import { Delete, Email, Phone } from '@material-ui/icons';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import {
	createTheme,
	ThemeProvider,
	withStyles,
} from '@material-ui/core/styles';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CopyToClipboard from 'react-copy-to-clipboard';
import { assignLeadSalesAgent } from '../../../api/Leads/assignLeadSalesAgent.api';
import { connect } from 'react-redux';
import styles from './LeadsItem.module.scss';
import { useDropdownStyle } from '../../../muiStyles/Dropdown.mui';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { checkRolesAccessibilities } from '../../../utils/checkRolesAccessibilities';

const LeadsItem = ({
	row,
	index,
	showManage,
	setShowManage,
	handleClickManage,
	isComponentVisible,
	ref,
	setIsComponentVisible,
	salesAgents,
	assignSalesAgentsDropdown,
	setAssignSalesAgentsDropdown,
	handleEditLead,
	handleClose,
	anchorEl,
	temporaryIdForDropdown,
	setTemporaryIdForDropdown,
	handleDeleteLead,
	handleLeadDetails,
	userType,
	rolesAccessibilities,
}) => {
	const [anchorElContact, setAnchorElContact] = useState();
	const [contactType, setContactType] = useState('');
	const [contactId, setContactId] = useState('');
	const statusDetails = (status) => {
		var details;
		if (status === 0) {
			details = {
				status: 'Schedule meeting',
				color: 'rgba(255, 158, 0, 0.8)',
			};
		} else if (status === 1) {
			details = {
				status: 'Appointment set',
				color: 'rgba(67, 138, 254, 0.8)',
			};
		}

		return details;
	};

	const handleChange = (e, leadsKey) => {
		setAssignSalesAgentsDropdown({
			...assignSalesAgentsDropdown,
			[leadsKey]: e.target.value,
		});

		assignLeadSalesAgent(leadsKey, e.target.value);
	};

	const styleShow = (index) => {
		console.log('showManageshowManage', showManage, index);
		if (Number(showManage) === Number(index)) {
			return { display: 'block' };
			// alert('test');
		} else {
			return { display: 'none' };
		}
	};

	const handleClickContactBtn = (event) => {
		setAnchorElContact(event.currentTarget);
		setContactType(event.currentTarget.dataset.contact);
		setContactId(event.currentTarget.dataset.id);
	};

	const handleCloseContactPopover = () => {
		setAnchorElContact();
		setContactType('');
		setContactId('');
	};

	const open = Boolean(anchorElContact);

	const classes = useDropdownStyle();

	return (
		<TableRow hover={true}>
			<TableCell
				className={`${styles.tableText} ${styles.leadsName}`}
				onClick={() => handleLeadDetails(row.leadId)}
			>
				{`${row.clientFName} ${row.clientLName}`}
				{(row.identification?.verification?.status === 'verified' ||
					row.identification?.verification?.status ===
						'manually_verified') && (
					<>
						<CheckCircle className={styles.verifiedChecker} />
					</>
				)}
			</TableCell>
			<TableCell>
				{dayjs(row?.createTimestamp).format('DD MMM YYYY')}
			</TableCell>
			{/* <TableCell className={styles.tableText}>
				{row?.postalCode?.slice(0, 3)}
			</TableCell> */}
			<TableCell>
				<div
					className={styles.status}
					style={{
						backgroundColor: `${
							statusDetails(row.sentEmail).color
						}`,
					}}
				>
					{statusDetails(row.sentEmail).status}
				</div>
			</TableCell>
			{checkRolesAccessibilities(
				rolesAccessibilities,
				userType,
				'deals',
				'leads',
				0
			) && (
				<TableCell>
					<FormControl>
						<TextField
							style={{
								borderRadius: '4px',
								minWidth: '200px',
								width: '200px',
								boxSizing: 'border-box',
								border: '0.1px solid #e0e0e0',
							}}
							variant='outlined'
							name={row?.leadId}
							value={assignSalesAgentsDropdown[row?.leadId]}
							onChange={(e) => handleChange(e, row?.leadsKey)}
							select
							defaultValue={row?.salesAgent && row?.salesAgent}
							SelectProps={{
								style: {
									backgroundColor: 'none',
									color: 'var(--primary-hover)',
									fontWeight: 'bold',
									height: '42px',

									'& .MuiSelectSelect:focus': {
										backgroundColor: 'white',
									},
								},

								MenuProps: {
									MenuListProps: { disablePadding: true },
								},
							}}
							className={styles.textFieldDropdown}
							MenuListProps={{ disablePadding: true }}
						>
							{salesAgents?.map((salesAgent, index) => (
								<MenuItem
									className={styles.agentItem}
									value={salesAgent.salesAgentId}
									classes={{
										selected: classes.menuItemSelected,
										root: classes.root,
									}}
									key={index}
								>
									{salesAgent.salesAgentName}
								</MenuItem>
							))}
						</TextField>
					</FormControl>
				</TableCell>
			)}
			<TableCell className={styles.contact_group}>
				<Tooltip title={'Email'}>
					<IconButton
						onClick={handleClickContactBtn}
						data-contact='email'
						data-id={row.leadsKey}
					>
						<Email className={styles.contact_btn} />
					</IconButton>
				</Tooltip>
				<Tooltip title={'Phone Number'}>
					<IconButton
						onClick={handleClickContactBtn}
						data-contact='phone'
						data-id={row.leadsKey}
					>
						<Phone className={styles.contact_btn} />
					</IconButton>
				</Tooltip>

				<Popover
					open={open && contactId === row.leadsKey}
					anchorEl={anchorElContact}
					onClose={handleCloseContactPopover}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'center',
					}}
					disableScrollLock
				>
					<div className={styles.contact_popover}>
						<p>
							{contactType === 'phone'
								? row.leadsPhoneNumber
								: contactType === 'email'
								? row.email
								: ''}
						</p>
						<CopyToClipboard
							text={
								contactType === 'phone'
									? row.leadsPhoneNumber
									: contactType === 'email'
									? row.email
									: ''
							}
							onCopy={handleCloseContactPopover}
							className={styles.copy_btn}
						>
							<Tooltip title={'Copy'}>
								<FileCopyIcon />
							</Tooltip>
						</CopyToClipboard>
					</div>
				</Popover>
			</TableCell>
			<TableCell>
				<Grid item className={styles.manageGroup}>
					<div
						aria-controls={`simple-menu${index}`}
						aria-haspopup='true'
						data-id={index}
						onClick={(e) => {
							setIsComponentVisible(true);
							handleClickManage(e);
							setTemporaryIdForDropdown(row.leadsKey);
						}}
					>
						<Tooltip title={'Other Actions'}>
							<MoreVertIcon className={styles.actionBtn} />
						</Tooltip>
					</div>

					<Menu
						id={`simple-menu${index}`}
						anchorEl={anchorEl}
						keepMounted
						open={Boolean(anchorEl)}
						onClose={handleClose}
						className={styles.manageDropdown}
						style={{ ...styleShow(index) }}
						MenuListProps={{ disablePadding: true }}
						PaperProps={{
							style: {
								boxShadow: '0px 1px 9px rgba(0, 0, 0, 0.1)',
								width: '173px',
							},
						}}
					>
						<MenuItem
							className={styles.dropdownItem}
							data-key={row.leadsKey}
							onClick={(e) =>
								handleEditLead(e, temporaryIdForDropdown)
							}
						>
							Edit
						</MenuItem>
						<hr />
						<MenuItem
							className={styles.dropdownItem}
							onClick={(e) =>
								handleDeleteLead(e, temporaryIdForDropdown)
							}
						>
							Delete
						</MenuItem>
					</Menu>
				</Grid>
			</TableCell>
		</TableRow>
	);
};

const mapStateToProps = (state) => ({
	modals: state.leads.modals,
	userType: state.signIn.userType,
	rolesAccessibilities: state.userManagement.rolesAccessibilities,
});

export default connect(mapStateToProps)(LeadsItem);
